module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img01-b65fab0cda38d1363b7f3183ef13584e.svg";